// HKDSE 2017 Paper 1 Knowledge Graph Samples - Complete Set
// Organized by question types with systematic naming

export const hkdse2017Samples_complete = {
  algebra: [
    {
      id: 'hkdse2017_algebra_01',
      problem: "Given that $y$ is the subject of the formula $k = \\frac{3x - y}{y}$.",
      problemType: "algebra_formula",
      difficulty: "fundamental",
      description: "Rearranging formula to make a variable the subject",
      graphData: {
        nodes: [
          {
            id: "fraction_equation",
            name: "Fraction Equation",
            type: "concepts",
            description: "Equation with fraction involving variable y",
            value: "k = (3x - y)/y",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "cross_multiplication",
            name: "Cross Multiplication",
            type: "concepts",
            description: "Method to eliminate fraction by multiplying both sides",
            value: "If a/b = c, then a = bc",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "step1_cross_multiply",
            name: "Step 1: Cross Multiply",
            type: "steps",
            description: "Multiply both sides by y to eliminate fraction",
            value: "3x - y = ky",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step2_collect_y_terms",
            name: "Step 2: Collect y Terms",
            type: "steps",
            description: "Move all y terms to one side",
            value: "3x = ky + y",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "step3_factor_y",
            name: "Step 3: Factor y",
            type: "steps",
            description: "Factor out y from right side",
            value: "3x = y(k + 1)",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "y expressed in terms of other variables",
            value: "y = 3x/(k + 1)",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "fraction_equation", to: "cross_multiplication", type: "requires", strength: 9 },
          { from: "cross_multiplication", to: "step1_cross_multiply", type: "enables", strength: 10 },
          { from: "step1_cross_multiply", to: "step2_collect_y_terms", type: "leads to", strength: 9 },
          { from: "step2_collect_y_terms", to: "step3_factor_y", type: "leads to", strength: 9 },
          { from: "step3_factor_y", to: "final_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'hkdse2017_algebra_02',
      problem: "Simplify $\\frac{(m^4 n^{-1})^3}{(m^{-2})^5}$ and express the answer in positive index form.",
      problemType: "algebra_indices",
      difficulty: "intermediate",
      description: "Simplifying expressions with negative indices",
      graphData: {
        nodes: [
          {
            id: "negative_indices",
            name: "Negative Indices",
            type: "concepts",
            description: "Understanding negative indices and their properties",
            value: "a⁻ⁿ = 1/aⁿ",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "power_of_power",
            name: "Power of Power",
            type: "concepts",
            description: "When raising a power to another power, multiply the indices",
            value: "(aᵐ)ⁿ = aᵐⁿ",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "division_of_powers",
            name: "Division of Powers",
            type: "concepts",
            description: "When dividing powers with the same base, subtract the indices",
            value: "aᵐ ÷ aⁿ = aᵐ⁻ⁿ",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step1_simplify_numerator",
            name: "Step 1: Simplify Numerator",
            type: "steps",
            description: "Apply power of power rule to (m⁴n⁻¹)³",
            value: "(m⁴n⁻¹)³ = m¹²n⁻³",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "step2_simplify_denominator",
            name: "Step 2: Simplify Denominator",
            type: "steps",
            description: "Apply power of power rule to (m⁻²)⁵",
            value: "(m⁻²)⁵ = m⁻¹⁰",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "step3_divide",
            name: "Step 3: Divide",
            type: "steps",
            description: "Divide numerator by denominator",
            value: "m¹²n⁻³ ÷ m⁻¹⁰ = m²²n⁻³",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "step4_convert_negative",
            name: "Step 4: Convert to Positive Indices",
            type: "steps",
            description: "Convert negative indices to positive using reciprocal",
            value: "m²²n⁻³ = m²²/n³",
            importance: 10,
            x: 0, y: 300, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "The simplified expression in positive indices",
            value: "m²²/n³",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "power_of_power", to: "step1_simplify_numerator", type: "enables", strength: 9 },
          { from: "power_of_power", to: "step2_simplify_denominator", type: "enables", strength: 9 },
          { from: "division_of_powers", to: "step3_divide", type: "enables", strength: 9 },
          { from: "step1_simplify_numerator", to: "step3_divide", type: "enables", strength: 9 },
          { from: "step2_simplify_denominator", to: "step3_divide", type: "enables", strength: 9 },
          { from: "negative_indices", to: "step4_convert_negative", type: "enables", strength: 10 },
          { from: "step3_divide", to: "step4_convert_negative", type: "leads to", strength: 10 },
          { from: "step4_convert_negative", to: "final_answer", type: "equals", strength: 10 }
        ]
      }
    }
  ],
  
  factorization: [
    {
      id: 'hkdse2017_factorization_01',
      problem: "Factorize: (a) $x^2 - 4xy + 3y^2$ (b) $x^2 - 4xy + 3y^2 + 11x - 33y$",
      problemType: "factorization",
      difficulty: "intermediate",
      description: "Factorization of quadratic expressions with multiple variables",
      graphData: {
        nodes: [
          {
            id: "quadratic_expression",
            name: "Quadratic Expression",
            type: "concepts",
            description: "Expression with x² and y² terms",
            value: "x² - 4xy + 3y²",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "ac_method",
            name: "AC Method",
            type: "concepts",
            description: "Method for factoring ax² + bx + c",
            value: "Find factors of ac that add to b",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "part_a_ac_method",
            name: "Part (a): AC Method",
            type: "steps",
            description: "Use AC method for x² - 4xy + 3y²",
            value: "AC = 1 × 3 = 3, factors: -1 and -3",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "part_a_split_middle",
            name: "Part (a): Split Middle Term",
            type: "steps",
            description: "Rewrite as x² - xy - 3xy + 3y²",
            value: "x² - xy - 3xy + 3y²",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_a_group_factor",
            name: "Part (a): Group and Factor",
            type: "steps",
            description: "Factor by grouping",
            value: "(x² - xy) + (-3xy + 3y²) = x(x - y) - 3y(x - y)",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "part_a_final",
            name: "Part (a): Final Answer",
            type: "values",
            description: "Factored form",
            value: "(x - y)(x - 3y)",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_rearrange",
            name: "Part (b): Rearrange",
            type: "steps",
            description: "Rearrange to use part (a)",
            value: "(x² - 4xy + 3y²) + (11x - 33y)",
            importance: 8,
            x: -200, y: 150, z: 0
          },
          {
            id: "part_b_substitute",
            name: "Part (b): Substitute",
            type: "steps",
            description: "Use result from part (a)",
            value: "(x - y)(x - 3y) + 11(x - 3y)",
            importance: 9,
            x: 200, y: 150, z: 0
          },
          {
            id: "part_b_final",
            name: "Part (b): Final Answer",
            type: "values",
            description: "Factored form for part (b)",
            value: "(x - 3y)(x - y + 11)",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "quadratic_expression", to: "ac_method", type: "requires", strength: 9 },
          { from: "ac_method", to: "part_a_ac_method", type: "enables", strength: 9 },
          { from: "part_a_ac_method", to: "part_a_split_middle", type: "leads to", strength: 8 },
          { from: "part_a_split_middle", to: "part_a_group_factor", type: "leads to", strength: 9 },
          { from: "part_a_group_factor", to: "part_a_final", type: "equals", strength: 10 },
          { from: "part_a_final", to: "part_b_rearrange", type: "enables", strength: 8 },
          { from: "part_b_rearrange", to: "part_b_substitute", type: "leads to", strength: 9 },
          { from: "part_b_substitute", to: "part_b_final", type: "equals", strength: 10 }
        ]
      }
    }
  ],
  
  word_problems: [
    {
      id: 'hkdse2017_word_problem_01',
      problem: "A theatre has only two types of tickets: regular tickets and discount tickets. The prices of regular tickets and discount tickets are $\\$126$ and $\\$78$ respectively. On a certain day, the number of regular tickets sold is $5$ times the number of discount tickets sold, and the total amount received from ticket sales is $\\$50976$. Find the total number of tickets sold on that day.",
      problemType: "word_problem_linear",
      difficulty: "intermediate",
      description: "Linear word problem with variables",
      graphData: {
        nodes: [
          {
            id: "ticket_types",
            name: "Ticket Types",
            type: "concepts",
            description: "Two types of tickets with different prices",
            value: "Regular: $126, Discount: $78",
            importance: 8,
            x: -200, y: -200, z: 0
          },
          {
            id: "relationship",
            name: "Relationship",
            type: "concepts",
            description: "Regular tickets 5 times discount tickets",
            value: "Let discount tickets = x, regular tickets = 5x",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "total_revenue",
            name: "Total Revenue",
            type: "concepts",
            description: "Total amount from ticket sales",
            value: "Total = $50,976",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "step1_setup_equation",
            name: "Step 1: Setup Equation",
            type: "steps",
            description: "Set up revenue equation",
            value: "126(5x) + 78x = 50976",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "step2_simplify",
            name: "Step 2: Simplify",
            type: "steps",
            description: "Simplify the equation",
            value: "630x + 78x = 50976",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "step3_solve",
            name: "Step 3: Solve for x",
            type: "steps",
            description: "Solve the linear equation",
            value: "708x = 50976 → x = 72",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "step4_find_total",
            name: "Step 4: Find Total",
            type: "steps",
            description: "Calculate total tickets",
            value: "Total = x + 5x = 6x = 432",
            importance: 10,
            x: 0, y: 300, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Total number of tickets sold",
            value: "432 tickets",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "ticket_types", to: "step1_setup_equation", type: "enables", strength: 8 },
          { from: "relationship", to: "step1_setup_equation", type: "enables", strength: 9 },
          { from: "total_revenue", to: "step1_setup_equation", type: "enables", strength: 9 },
          { from: "step1_setup_equation", to: "step2_simplify", type: "leads to", strength: 8 },
          { from: "step2_simplify", to: "step3_solve", type: "leads to", strength: 9 },
          { from: "step3_solve", to: "step4_find_total", type: "enables", strength: 10 },
          { from: "step4_find_total", to: "final_answer", type: "equals", strength: 10 }
        ]
      }
    }
  ],
  
  inequalities: [
    {
      id: 'hkdse2017_inequalities_01',
      problem: "(a) Find the range of values of $x$ which satisfy both $7(x - 2) \\leq \\frac{11x + 8}{3}$ and $6 - x < 5$. (b) How many integers satisfy the inequality in part (a)?",
      problemType: "inequalities_compound",
      difficulty: "intermediate",
      description: "Solving compound inequalities and counting integer solutions",
      graphData: {
        nodes: [
          {
            id: "compound_inequalities",
            name: "Compound Inequalities",
            type: "concepts",
            description: "Two inequalities that must both be satisfied",
            value: "Inequality 1 AND Inequality 2",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "inequality1",
            name: "Inequality 1",
            type: "concepts",
            description: "First inequality to solve",
            value: "7(x - 2) ≤ (11x + 8)/3",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "inequality2",
            name: "Inequality 2",
            type: "concepts",
            description: "Second inequality to solve",
            value: "6 - x < 5",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step1_solve_ineq1",
            name: "Step 1: Solve Inequality 1",
            type: "steps",
            description: "Solve 7(x - 2) ≤ (11x + 8)/3",
            value: "21(x - 2) ≤ 11x + 8",
            importance: 9,
            x: -200, y: 0, z: 25
          },
          {
            id: "step1a_expand",
            name: "Step 1a: Expand",
            type: "steps",
            description: "Expand left side",
            value: "21x - 42 ≤ 11x + 8",
            importance: 8,
            x: -200, y: 50, z: 0
          },
          {
            id: "step1b_collect_terms",
            name: "Step 1b: Collect Terms",
            type: "steps",
            description: "Collect like terms",
            value: "10x ≤ 50",
            importance: 8,
            x: -200, y: 100, z: 0
          },
          {
            id: "step1c_solve",
            name: "Step 1c: Solve for x",
            type: "steps",
            description: "Solve the inequality",
            value: "x ≤ 5",
            importance: 9,
            x: -200, y: 150, z: 0
          },
          {
            id: "step2_solve_ineq2",
            name: "Step 2: Solve Inequality 2",
            type: "steps",
            description: "Solve 6 - x < 5",
            value: "x > 1",
            importance: 8,
            x: 200, y: 0, z: 25
          },
          {
            id: "step3_combine",
            name: "Step 3: Combine Solutions",
            type: "steps",
            description: "Find intersection of both solutions",
            value: "x > 1 AND x ≤ 5",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "part_a_final",
            name: "Part (a): Final Answer",
            type: "steps",
            description: "Range of values satisfying both inequalities",
            value: "1 < x ≤ 5",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_count_integers",
            name: "Part (b): Count Integers",
            type: "steps",
            description: "Count integer solutions",
            value: "x = 2, 3, 4, 5 → 4 integers",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) 1 < x ≤ 5 (b) 4",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "compound_inequalities", to: "inequality1", type: "includes", strength: 9 },
          { from: "compound_inequalities", to: "inequality2", type: "includes", strength: 9 },
          { from: "inequality1", to: "step1_solve_ineq1", type: "requires", strength: 9 },
          { from: "step1_solve_ineq1", to: "step1a_expand", type: "leads to", strength: 8 },
          { from: "step1a_expand", to: "step1b_collect_terms", type: "leads to", strength: 8 },
          { from: "step1b_collect_terms", to: "step1c_solve", type: "leads to", strength: 9 },
          { from: "inequality2", to: "step2_solve_ineq2", type: "requires", strength: 8 },
          { from: "step1c_solve", to: "step3_combine", type: "enables", strength: 9 },
          { from: "step2_solve_ineq2", to: "step3_combine", type: "enables", strength: 9 },
          { from: "step3_combine", to: "part_a_final", type: "equals", strength: 10 },
          { from: "part_a_final", to: "part_b_count_integers", type: "enables", strength: 8 },
          { from: "part_a_final", to: "final_answer", type: "contributes to", strength: 10 },
          { from: "part_b_count_integers", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ],
  
  geometry: [
    {
      id: 'hkdse2017_geometry_01',
      problem: "The coordinates of points $A$ and $B$ are $(-3, 4)$ and $(9, -9)$ respectively. $A$ rotates counterclockwise about the origin by $90°$ to $A'$. $B'$ is the reflection image of $B$ with respect to the $x$-axis. (a) Write down the coordinates of $A'$ and $B'$. (b) Prove that $AB$ is perpendicular to $A'B'$.",
      problemType: "geometry_transformations",
      difficulty: "intermediate",
      description: "Working with rotations, reflections and perpendicular lines",
      graphData: {
        nodes: [
          {
            id: "rotation_90_degrees",
            name: "Rotation 90° Counterclockwise",
            type: "concepts",
            description: "Rotation transformation about origin",
            value: "(x, y) → (-y, x)",
            importance: 10,
            x: -200, y: -200, z: 0
          },
          {
            id: "reflection_x_axis",
            name: "Reflection in x-axis",
            type: "concepts",
            description: "Reflection transformation",
            value: "(x, y) → (x, -y)",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_find_a_prime",
            name: "Part (a): Find A'",
            type: "steps",
            description: "Rotate A(-3, 4) by 90° counterclockwise",
            value: "A' = (-4, -3)",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "part_a_find_b_prime",
            name: "Part (a): Find B'",
            type: "steps",
            description: "Reflect B(9, -9) in x-axis",
            value: "B' = (9, 9)",
            importance: 9,
            x: -200, y: 0, z: 25
          },
          {
            id: "part_b_slope_ab",
            name: "Part (b): Slope AB",
            type: "steps",
            description: "Calculate slope of AB",
            value: "Slope AB = (-9-4)/(9-(-3)) = -13/12",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_b_slope_a_prime_b_prime",
            name: "Part (b): Slope A'B'",
            type: "steps",
            description: "Calculate slope of A'B'",
            value: "Slope A'B' = (9-(-3))/(9-(-4)) = 12/13",
            importance: 8,
            x: 200, y: 0, z: 25
          },
          {
            id: "part_b_perpendicular_check",
            name: "Part (b): Perpendicular Check",
            type: "steps",
            description: "Check if slopes are negative reciprocals",
            value: "(-13/12) × (12/13) = -1 ✓",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) A'(-4, -3), B'(9, 9) (b) Perpendicular (slopes multiply to -1)",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "rotation_90_degrees", to: "part_a_find_a_prime", type: "enables", strength: 10 },
          { from: "reflection_x_axis", to: "part_a_find_b_prime", type: "enables", strength: 9 },
          { from: "part_a_find_a_prime", to: "part_b_slope_a_prime_b_prime", type: "enables", strength: 8 },
          { from: "part_a_find_b_prime", to: "part_b_slope_a_prime_b_prime", type: "enables", strength: 8 },
          { from: "part_b_slope_ab", to: "part_b_perpendicular_check", type: "enables", strength: 9 },
          { from: "part_b_slope_a_prime_b_prime", to: "part_b_perpendicular_check", type: "enables", strength: 9 },
          { from: "part_a_find_a_prime", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_a_find_b_prime", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_perpendicular_check", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  statistics: [
    {
      id: 'hkdse2017_statistics_01',
      problem: "The following pie chart shows the distribution of birth seasons of students in a certain school. Pie chart description: A circular pie chart divided into four sectors representing the four seasons. The sectors are labeled as follows: Summer (top right sector marked with 158°), Autumn (top left sector), Winter (bottom left sector), and Spring (bottom right sector marked with x°). If a student is randomly selected from the school, the probability that the selected student was born in spring is $\\frac{1}{9}$. (a) Find $x$. (b) The school has $180$ students born in winter. Find the total number of students in the school.",
      problemType: "statistics_pie_chart",
      difficulty: "intermediate",
      description: "Working with pie charts and probability",
      graphData: {
        nodes: [
          {
            id: "pie_chart_angles",
            name: "Pie Chart Angles",
            type: "concepts",
            description: "Angles in pie chart represent proportions",
            value: "Total angle = 360°",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "probability_spring",
            name: "Probability Spring",
            type: "concepts",
            description: "Probability of being born in spring",
            value: "P(Spring) = 1/9",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "step1_find_spring_angle",
            name: "Step 1: Find Spring Angle",
            type: "steps",
            description: "Calculate angle for spring",
            value: "Spring angle = (1/9) × 360° = 40°",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "part_a_find_x",
            name: "Part (a): Find x",
            type: "steps",
            description: "x is the spring angle",
            value: "x = 40°",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_b_find_winter_angle",
            name: "Part (b): Find Winter Angle",
            type: "steps",
            description: "Calculate remaining angle for winter",
            value: "Winter angle = 360° - 158° - x° - Autumn angle",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "part_b_proportion",
            name: "Part (b): Use Proportion",
            type: "steps",
            description: "Use proportion to find total students",
            value: "180/total = winter_angle/360°",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_calculation",
            name: "Part (b): Calculation",
            type: "steps",
            description: "Calculate total number of students",
            value: "Total = 180 × 360°/winter_angle",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) 40° (b) 810 students",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "pie_chart_angles", to: "step1_find_spring_angle", type: "enables", strength: 9 },
          { from: "probability_spring", to: "step1_find_spring_angle", type: "enables", strength: 9 },
          { from: "step1_find_spring_angle", to: "part_a_find_x", type: "leads to", strength: 10 },
          { from: "part_a_find_x", to: "part_b_find_winter_angle", type: "enables", strength: 8 },
          { from: "part_b_find_winter_angle", to: "part_b_proportion", type: "enables", strength: 8 },
          { from: "part_b_proportion", to: "part_b_calculation", type: "leads to", strength: 8 },
          { from: "part_a_find_x", to: "final_answer", type: "contributes to", strength: 10 },
          { from: "part_b_calculation", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ]
}; 